/* eslint-disable */
import * as Types from '../../graphqlTypes';

import { gql } from '@apollo/client';
export type ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterBoolFilterComputed_Fragment = { __typename: 'ProductSearchPropertyFilterBoolFilterComputed', key: string, expr: string, valueBoolComputed?: boolean | null, missingValue: boolean, operatorBool: Types.ProductSearchBoolFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterBoolInFilterComputed_Fragment = { __typename: 'ProductSearchPropertyFilterBoolInFilterComputed', key: string, expr: string, valueBoolInComputed?: Array<boolean> | null, missingValue: boolean, operatorBoolIn: Types.ProductSearchBoolInFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterNumberBetweenFilterComputed_Fragment = { __typename: 'ProductSearchPropertyFilterNumberBetweenFilterComputed', key: string, expr: string, missingValue: boolean, operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null };

export type ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterNumberFilterComputed_Fragment = { __typename: 'ProductSearchPropertyFilterNumberFilterComputed', key: string, expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.ProductSearchNumberFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterNumberInFilterComputed_Fragment = { __typename: 'ProductSearchPropertyFilterNumberInFilterComputed', key: string, expr: string, valueNumberInComputed?: Array<number> | null, missingValue: boolean, operatorNumberIn: Types.ProductSearchNumberInFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterTextFilterComputed_Fragment = { __typename: 'ProductSearchPropertyFilterTextFilterComputed', key: string, expr: string, valueTextComputed?: string | null, missingValue: boolean, operatorText: Types.ProductSearchTextFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterTextInFilterComputed_Fragment = { __typename: 'ProductSearchPropertyFilterTextInFilterComputed', key: string, expr: string, valueTextInComputed?: Array<string> | null, missingValue: boolean, operatorTextIn: Types.ProductSearchTextInFilterOperator };

export type ItemProductSearchFilterPropertyFilterComputedFragment = ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterBoolFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterBoolInFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterNumberBetweenFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterNumberFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterNumberInFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterTextFilterComputed_Fragment | ItemProductSearchFilterPropertyFilterComputed_ProductSearchPropertyFilterTextInFilterComputed_Fragment;

export type ItemProductSearchFilterPriceFilterComputed_ProductSearchNumberBetweenFilterComputed_Fragment = { __typename: 'ProductSearchNumberBetweenFilterComputed', expr: string, missingValue: boolean, operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null };

export type ItemProductSearchFilterPriceFilterComputed_ProductSearchNumberFilterComputed_Fragment = { __typename: 'ProductSearchNumberFilterComputed', expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.ProductSearchNumberFilterOperator };

export type ItemProductSearchFilterPriceFilterComputedFragment = ItemProductSearchFilterPriceFilterComputed_ProductSearchNumberBetweenFilterComputed_Fragment | ItemProductSearchFilterPriceFilterComputed_ProductSearchNumberFilterComputed_Fragment;

export type ItemProductSearchFilterBrandFilterComputed_ProductSearchTextFilterComputed_Fragment = { __typename: 'ProductSearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.ProductSearchTextFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandFilterComputed_ProductSearchTextInFilterComputed_Fragment = { __typename: 'ProductSearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.ProductSearchTextInFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandFilterComputedFragment = ItemProductSearchFilterBrandFilterComputed_ProductSearchTextFilterComputed_Fragment | ItemProductSearchFilterBrandFilterComputed_ProductSearchTextInFilterComputed_Fragment;

export type ItemProductSearchFilterBrandLineFilterComputed_ProductSearchTextFilterComputed_Fragment = { __typename: 'ProductSearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.ProductSearchTextFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandLineFilterComputed_ProductSearchTextInFilterComputed_Fragment = { __typename: 'ProductSearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.ProductSearchTextInFilterOperator, expr: string, missingValue: boolean };

export type ItemProductSearchFilterBrandLineFilterComputedFragment = ItemProductSearchFilterBrandLineFilterComputed_ProductSearchTextFilterComputed_Fragment | ItemProductSearchFilterBrandLineFilterComputed_ProductSearchTextInFilterComputed_Fragment;

export type ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterBoolFilter_Fragment = { __typename: 'ProductSearchPropertyFilterBoolFilter', key: string, operatorBool: Types.ProductSearchBoolFilterOperator, valueBool: boolean };

export type ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterBoolInFilter_Fragment = { __typename: 'ProductSearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.ProductSearchBoolInFilterOperator, valueBoolIn: Array<boolean> };

export type ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterNumberBetweenFilter_Fragment = { __typename: 'ProductSearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } };

export type ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterNumberFilter_Fragment = { __typename: 'ProductSearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number };

export type ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterNumberInFilter_Fragment = { __typename: 'ProductSearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.ProductSearchNumberInFilterOperator, valueNumberIn: Array<number> };

export type ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterTextFilter_Fragment = { __typename: 'ProductSearchPropertyFilterTextFilter', key: string, operatorText: Types.ProductSearchTextFilterOperator, valueText: string };

export type ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterTextInFilter_Fragment = { __typename: 'ProductSearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.ProductSearchTextInFilterOperator, valueTextIn: Array<string> };

export type ItemProductSearchFilterPropertyFilterFragment = ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterBoolFilter_Fragment | ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterBoolInFilter_Fragment | ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterNumberBetweenFilter_Fragment | ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterNumberFilter_Fragment | ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterNumberInFilter_Fragment | ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterTextFilter_Fragment | ItemProductSearchFilterPropertyFilter_ProductSearchPropertyFilterTextInFilter_Fragment;

export type ItemProductSearchFilterPriceFilter_ProductSearchNumberBetweenFilter_Fragment = { __typename: 'ProductSearchNumberBetweenFilter', operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } };

export type ItemProductSearchFilterPriceFilter_ProductSearchNumberFilter_Fragment = { __typename: 'ProductSearchNumberFilter', operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number };

export type ItemProductSearchFilterPriceFilterFragment = ItemProductSearchFilterPriceFilter_ProductSearchNumberBetweenFilter_Fragment | ItemProductSearchFilterPriceFilter_ProductSearchNumberFilter_Fragment;

export type ItemProductSearchFilterIdFilter_ItemProductSearchIdFilter_Fragment = { __typename: 'ItemProductSearchIdFilter', valueId: string, operatorId: Types.ProductSearchIdFilterOperator };

export type ItemProductSearchFilterIdFilter_ItemProductSearchIdInFilter_Fragment = { __typename: 'ItemProductSearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.ProductSearchIdInFilterOperator };

export type ItemProductSearchFilterIdFilterFragment = ItemProductSearchFilterIdFilter_ItemProductSearchIdFilter_Fragment | ItemProductSearchFilterIdFilter_ItemProductSearchIdInFilter_Fragment;

export type ItemProductSearchIdFilterFragment = { __typename: 'ItemProductSearchIdFilter', valueId: string, operatorId: Types.ProductSearchIdFilterOperator };

export type ItemProductSearchFilterBrandFilter_ProductSearchTextFilter_Fragment = { __typename: 'ProductSearchTextFilter', valueText: string, operatorText: Types.ProductSearchTextFilterOperator };

export type ItemProductSearchFilterBrandFilter_ProductSearchTextInFilter_Fragment = { __typename: 'ProductSearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.ProductSearchTextInFilterOperator };

export type ItemProductSearchFilterBrandFilterFragment = ItemProductSearchFilterBrandFilter_ProductSearchTextFilter_Fragment | ItemProductSearchFilterBrandFilter_ProductSearchTextInFilter_Fragment;

export type ItemProductSearchFilterBrandLineFilter_ProductSearchTextFilter_Fragment = { __typename: 'ProductSearchTextFilter', valueText: string, operatorText: Types.ProductSearchTextFilterOperator };

export type ItemProductSearchFilterBrandLineFilter_ProductSearchTextInFilter_Fragment = { __typename: 'ProductSearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.ProductSearchTextInFilterOperator };

export type ItemProductSearchFilterBrandLineFilterFragment = ItemProductSearchFilterBrandLineFilter_ProductSearchTextFilter_Fragment | ItemProductSearchFilterBrandLineFilter_ProductSearchTextInFilter_Fragment;

export type ItemProductSearchFilterExpressionsFragment = { __typename: 'ItemProductSearchFilterExpressions', itemId: string, brandFilter?: { __typename: 'ProductSearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.ProductSearchTextFilterOperator, expr: string, missingValue: boolean } | { __typename: 'ProductSearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.ProductSearchTextInFilterOperator, expr: string, missingValue: boolean } | null, brandLineFilter?: { __typename: 'ProductSearchTextFilterComputed', valueTextComputed?: string | null, operatorText: Types.ProductSearchTextFilterOperator, expr: string, missingValue: boolean } | { __typename: 'ProductSearchTextInFilterComputed', valueTextInComputed?: Array<string> | null, operatorTextIn: Types.ProductSearchTextInFilterOperator, expr: string, missingValue: boolean } | null, listPriceFilter?: { __typename: 'ProductSearchNumberBetweenFilterComputed', expr: string, missingValue: boolean, operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'ProductSearchNumberFilterComputed', expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.ProductSearchNumberFilterOperator } | null, propertyFilters: Array<{ __typename: 'ProductSearchPropertyFilterBoolFilterComputed', key: string, expr: string, valueBoolComputed?: boolean | null, missingValue: boolean, operatorBool: Types.ProductSearchBoolFilterOperator } | { __typename: 'ProductSearchPropertyFilterBoolInFilterComputed', key: string, expr: string, valueBoolInComputed?: Array<boolean> | null, missingValue: boolean, operatorBoolIn: Types.ProductSearchBoolInFilterOperator } | { __typename: 'ProductSearchPropertyFilterNumberBetweenFilterComputed', key: string, expr: string, missingValue: boolean, operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetweenComputed?: { __typename: 'ValueNumberBetween', min: number, max: number } | null } | { __typename: 'ProductSearchPropertyFilterNumberFilterComputed', key: string, expr: string, valueNumberComputed?: number | null, missingValue: boolean, operatorNumber: Types.ProductSearchNumberFilterOperator } | { __typename: 'ProductSearchPropertyFilterNumberInFilterComputed', key: string, expr: string, valueNumberInComputed?: Array<number> | null, missingValue: boolean, operatorNumberIn: Types.ProductSearchNumberInFilterOperator } | { __typename: 'ProductSearchPropertyFilterTextFilterComputed', key: string, expr: string, valueTextComputed?: string | null, missingValue: boolean, operatorText: Types.ProductSearchTextFilterOperator } | { __typename: 'ProductSearchPropertyFilterTextInFilterComputed', key: string, expr: string, valueTextInComputed?: Array<string> | null, missingValue: boolean, operatorTextIn: Types.ProductSearchTextInFilterOperator }> };

export type ItemProductSearchFilterDefinitionsFragment = { __typename: 'ItemProductSearchFilterDefinitions', itemId: string, favouritesFilter?: { __typename: 'ProductSearchBoolFilter', valueBool: boolean, operatorBool: Types.ProductSearchBoolFilterOperator } | null, productTypeIdFilter?: { __typename: 'ItemProductSearchIdFilter', valueId: string, operatorId: Types.ProductSearchIdFilterOperator } | null, supplierIdFilter?: { __typename: 'ItemProductSearchIdFilter', valueId: string, operatorId: Types.ProductSearchIdFilterOperator } | { __typename: 'ItemProductSearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.ProductSearchIdInFilterOperator } | null, brandFilter?: { __typename: 'ProductSearchTextFilter', valueText: string, operatorText: Types.ProductSearchTextFilterOperator } | { __typename: 'ProductSearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.ProductSearchTextInFilterOperator } | null, brandLineFilter?: { __typename: 'ProductSearchTextFilter', valueText: string, operatorText: Types.ProductSearchTextFilterOperator } | { __typename: 'ProductSearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.ProductSearchTextInFilterOperator } | null, listPriceFilter?: { __typename: 'ProductSearchNumberBetweenFilter', operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'ProductSearchNumberFilter', operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number } | null, netPriceFilter?: { __typename: 'ProductSearchNumberBetweenFilter', operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'ProductSearchNumberFilter', operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number } | null, propertyFilters: Array<{ __typename: 'ProductSearchPropertyFilterBoolFilter', key: string, operatorBool: Types.ProductSearchBoolFilterOperator, valueBool: boolean } | { __typename: 'ProductSearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.ProductSearchBoolInFilterOperator, valueBoolIn: Array<boolean> } | { __typename: 'ProductSearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'ProductSearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number } | { __typename: 'ProductSearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.ProductSearchNumberInFilterOperator, valueNumberIn: Array<number> } | { __typename: 'ProductSearchPropertyFilterTextFilter', key: string, operatorText: Types.ProductSearchTextFilterOperator, valueText: string } | { __typename: 'ProductSearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.ProductSearchTextInFilterOperator, valueTextIn: Array<string> }> };

export type ItemProductSearchFilterDefaultsFragment = { __typename: 'ItemProductSearchFilterDefaults', itemId: string, favouritesFilter?: { __typename: 'ProductSearchBoolFilter', valueBool: boolean, operatorBool: Types.ProductSearchBoolFilterOperator } | null, productTypeIdFilter?: { __typename: 'ItemProductSearchIdFilter', valueId: string, operatorId: Types.ProductSearchIdFilterOperator } | null, supplierIdFilter?: { __typename: 'ItemProductSearchIdFilter', valueId: string, operatorId: Types.ProductSearchIdFilterOperator } | { __typename: 'ItemProductSearchIdInFilter', valueIdIn: Array<string>, operatorIdIn: Types.ProductSearchIdInFilterOperator } | null, brandFilter?: { __typename: 'ProductSearchTextFilter', valueText: string, operatorText: Types.ProductSearchTextFilterOperator } | { __typename: 'ProductSearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.ProductSearchTextInFilterOperator } | null, brandLineFilter?: { __typename: 'ProductSearchTextFilter', valueText: string, operatorText: Types.ProductSearchTextFilterOperator } | { __typename: 'ProductSearchTextInFilter', valueTextIn: Array<string>, operatorTextIn: Types.ProductSearchTextInFilterOperator } | null, listPriceFilter?: { __typename: 'ProductSearchNumberBetweenFilter', operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'ProductSearchNumberFilter', operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number } | null, netPriceFilter?: { __typename: 'ProductSearchNumberBetweenFilter', operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'ProductSearchNumberFilter', operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number } | null, propertyFilters: Array<{ __typename: 'ProductSearchPropertyFilterBoolFilter', key: string, operatorBool: Types.ProductSearchBoolFilterOperator, valueBool: boolean } | { __typename: 'ProductSearchPropertyFilterBoolInFilter', key: string, operatorBoolIn: Types.ProductSearchBoolInFilterOperator, valueBoolIn: Array<boolean> } | { __typename: 'ProductSearchPropertyFilterNumberBetweenFilter', key: string, operatorNumberBetween: Types.ProductSearchNumberBetweenFilterOperator, valueNumberBetween: { __typename: 'ValueNumberBetween', min: number, max: number } } | { __typename: 'ProductSearchPropertyFilterNumberFilter', key: string, operatorNumber: Types.ProductSearchNumberFilterOperator, valueNumber: number } | { __typename: 'ProductSearchPropertyFilterNumberInFilter', key: string, operatorNumberIn: Types.ProductSearchNumberInFilterOperator, valueNumberIn: Array<number> } | { __typename: 'ProductSearchPropertyFilterTextFilter', key: string, operatorText: Types.ProductSearchTextFilterOperator, valueText: string } | { __typename: 'ProductSearchPropertyFilterTextInFilter', key: string, operatorTextIn: Types.ProductSearchTextInFilterOperator, valueTextIn: Array<string> }> };

export const ItemProductSearchFilterBrandFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandFilterComputed on ItemProductSearchFilterBrandFilterComputed {
  ... on ProductSearchTextFilterComputed {
    valueTextComputed
    operatorText
    expr
    missingValue
  }
  ... on ProductSearchTextInFilterComputed {
    valueTextInComputed
    operatorTextIn
    expr
    missingValue
  }
}
    `;
export const ItemProductSearchFilterBrandLineFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandLineFilterComputed on ItemProductSearchFilterBrandLineFilterComputed {
  ... on ProductSearchTextFilterComputed {
    valueTextComputed
    operatorText
    expr
    missingValue
  }
  ... on ProductSearchTextInFilterComputed {
    valueTextInComputed
    operatorTextIn
    expr
    missingValue
  }
}
    `;
export const ItemProductSearchFilterPriceFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterPriceFilterComputed on ItemProductSearchFilterPriceFilterComputed {
  ... on ProductSearchNumberFilterComputed {
    expr
    valueNumberComputed
    missingValue
    operatorNumber
  }
  ... on ProductSearchNumberBetweenFilterComputed {
    expr
    valueNumberBetweenComputed {
      min
      max
    }
    missingValue
    operatorNumberBetween
  }
}
    `;
export const ItemProductSearchFilterPropertyFilterComputedFragmentDoc = gql`
    fragment ItemProductSearchFilterPropertyFilterComputed on ItemProductSearchFilterPropertyFilterComputed {
  ... on ProductSearchPropertyFilterNumberFilterComputed {
    key
    expr
    valueNumberComputed
    missingValue
    operatorNumber
  }
  ... on ProductSearchPropertyFilterNumberInFilterComputed {
    key
    expr
    valueNumberInComputed
    missingValue
    operatorNumberIn
  }
  ... on ProductSearchPropertyFilterNumberBetweenFilterComputed {
    key
    expr
    valueNumberBetweenComputed {
      min
      max
    }
    missingValue
    operatorNumberBetween
  }
  ... on ProductSearchPropertyFilterTextFilterComputed {
    key
    expr
    valueTextComputed
    missingValue
    operatorText
  }
  ... on ProductSearchPropertyFilterTextInFilterComputed {
    key
    expr
    valueTextInComputed
    missingValue
    operatorTextIn
  }
  ... on ProductSearchPropertyFilterBoolFilterComputed {
    key
    expr
    valueBoolComputed
    missingValue
    operatorBool
  }
  ... on ProductSearchPropertyFilterBoolInFilterComputed {
    key
    expr
    valueBoolInComputed
    missingValue
    operatorBoolIn
  }
}
    `;
export const ItemProductSearchFilterExpressionsFragmentDoc = gql`
    fragment ItemProductSearchFilterExpressions on ItemProductSearchFilterExpressions {
  itemId
  brandFilter {
    ...ItemProductSearchFilterBrandFilterComputed
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilterComputed
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilterComputed
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilterComputed
  }
}
    ${ItemProductSearchFilterBrandFilterComputedFragmentDoc}
${ItemProductSearchFilterBrandLineFilterComputedFragmentDoc}
${ItemProductSearchFilterPriceFilterComputedFragmentDoc}
${ItemProductSearchFilterPropertyFilterComputedFragmentDoc}`;
export const ItemProductSearchIdFilterFragmentDoc = gql`
    fragment ItemProductSearchIdFilter on ItemProductSearchIdFilter {
  valueId
  operatorId
}
    `;
export const ItemProductSearchFilterIdFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterIdFilter on ItemProductSearchFilterIdFilter {
  ...ItemProductSearchIdFilter
  ... on ItemProductSearchIdInFilter {
    valueIdIn
    operatorIdIn
  }
}
    ${ItemProductSearchIdFilterFragmentDoc}`;
export const ItemProductSearchFilterBrandFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandFilter on ItemProductSearchFilterBrandFilter {
  ... on ProductSearchTextFilter {
    valueText
    operatorText
  }
  ... on ProductSearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
}
    `;
export const ItemProductSearchFilterBrandLineFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterBrandLineFilter on ItemProductSearchFilterBrandLineFilter {
  ... on ProductSearchTextFilter {
    valueText
    operatorText
  }
  ... on ProductSearchTextInFilter {
    valueTextIn
    operatorTextIn
  }
}
    `;
export const ItemProductSearchFilterPriceFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterPriceFilter on ItemProductSearchFilterPriceFilter {
  ... on ProductSearchNumberFilter {
    operatorNumber
    valueNumber
  }
  ... on ProductSearchNumberBetweenFilter {
    operatorNumberBetween
    valueNumberBetween {
      min
      max
    }
  }
}
    `;
export const ItemProductSearchFilterPropertyFilterFragmentDoc = gql`
    fragment ItemProductSearchFilterPropertyFilter on ItemProductSearchFilterPropertyFilter {
  ... on ProductSearchPropertyFilterBoolFilter {
    key
    operatorBool
    valueBool
  }
  ... on ProductSearchPropertyFilterBoolInFilter {
    key
    operatorBoolIn
    valueBoolIn
  }
  ... on ProductSearchPropertyFilterNumberFilter {
    key
    operatorNumber
    valueNumber
  }
  ... on ProductSearchPropertyFilterNumberInFilter {
    key
    operatorNumberIn
    valueNumberIn
  }
  ... on ProductSearchPropertyFilterNumberBetweenFilter {
    key
    operatorNumberBetween
    valueNumberBetween {
      min
      max
    }
  }
  ... on ProductSearchPropertyFilterTextFilter {
    key
    operatorText
    valueText
  }
  ... on ProductSearchPropertyFilterTextInFilter {
    key
    operatorTextIn
    valueTextIn
  }
}
    `;
export const ItemProductSearchFilterDefinitionsFragmentDoc = gql`
    fragment ItemProductSearchFilterDefinitions on ItemProductSearchFilterDefinitions {
  itemId
  favouritesFilter {
    ... on ProductSearchBoolFilter {
      valueBool
      operatorBool
    }
  }
  productTypeIdFilter {
    ...ItemProductSearchIdFilter
  }
  supplierIdFilter {
    ...ItemProductSearchFilterIdFilter
  }
  brandFilter {
    ...ItemProductSearchFilterBrandFilter
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilter
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  netPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilter
  }
}
    ${ItemProductSearchIdFilterFragmentDoc}
${ItemProductSearchFilterIdFilterFragmentDoc}
${ItemProductSearchFilterBrandFilterFragmentDoc}
${ItemProductSearchFilterBrandLineFilterFragmentDoc}
${ItemProductSearchFilterPriceFilterFragmentDoc}
${ItemProductSearchFilterPropertyFilterFragmentDoc}`;
export const ItemProductSearchFilterDefaultsFragmentDoc = gql`
    fragment ItemProductSearchFilterDefaults on ItemProductSearchFilterDefaults {
  itemId
  favouritesFilter {
    ... on ProductSearchBoolFilter {
      valueBool
      operatorBool
    }
  }
  productTypeIdFilter {
    ...ItemProductSearchIdFilter
  }
  supplierIdFilter {
    ...ItemProductSearchFilterIdFilter
  }
  brandFilter {
    ...ItemProductSearchFilterBrandFilter
  }
  brandLineFilter {
    ...ItemProductSearchFilterBrandLineFilter
  }
  listPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  netPriceFilter {
    ...ItemProductSearchFilterPriceFilter
  }
  propertyFilters {
    ...ItemProductSearchFilterPropertyFilter
  }
}
    ${ItemProductSearchIdFilterFragmentDoc}
${ItemProductSearchFilterIdFilterFragmentDoc}
${ItemProductSearchFilterBrandFilterFragmentDoc}
${ItemProductSearchFilterBrandLineFilterFragmentDoc}
${ItemProductSearchFilterPriceFilterFragmentDoc}
${ItemProductSearchFilterPropertyFilterFragmentDoc}`;